import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-install-device-report',
  templateUrl: './install-device-report.component.html',
  styleUrls: ['./install-device-report.component.scss']
})
export class InstallDeviceReportComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();


  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe:DatePipe
  ) { }
  showDatePickers: boolean = false;  
  fromDate: string | null = null;  
  toDate: string | null = null;    

  ngOnInit(): void {
    this.ViewDevices();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Device Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Device Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Device Master' 
        },
       
      ]
    };
  }

  ShowReport(){
    let dateTime = this.datePipe.transform($("#dateTime").val(),"yyyy-MM-dd");
    let fromDate = dateTime+" 00:00:00";
    let toDate = dateTime+" 23:59:59";
    // console.log(fromDate+" :: "+toDate);
  }

//View Devices
  deviceRowdata;
  deviceDetails=[];
  isLoading=false;
  async ViewDevices(){
    try {
      this.isLoading=true;
      // alert("here");
      const device = {
        'device_id': "",
      };
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/master/view_device',device);
      this.deviceDetails=[];
      //alert(data);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            if(dataObj[objKey1].manufacturing_date==0){
              dataObj[objKey1].manufacturing_date = dataObj[objKey1].date_time;
            }
            dataObj[objKey1].manufacturing_date = this.normalizeTimestamp(Number(dataObj[objKey1].manufacturing_date));
            dataObj[objKey1].date_time = this.normalizeTimestamp(Number(dataObj[objKey1].date_time));
            this.deviceDetails.push(dataObj[objKey1]);
          } 
        }				
      }
      this.deviceRowdata = this.deviceDetails;
      this.isLoading=false;
      // console.log(this.deviceRowdata);
    } catch (error) {}
  }

  normalizeTimestamp(timestamp: number): number {
    const length = timestamp.toString().length;

    if (length === 10) {
      // Convert seconds → milliseconds
      return timestamp * 1000;
    } else if (length === 13) {
      // Already in milliseconds
      return timestamp;
    } else {
      throw new Error("Invalid timestamp format");
    }
  }
  
}
